angular.module('app.directives').directive('vpAreaMove', ($window, $translate, notify, api) => ({
    restrict: 'EA',

    scope: {
        model: '=?',
    },

    controller($scope) {
        const AreaModel = api('areas');
        $scope.step = 1;

        $scope.areaOptions = [];
        AreaModel.selectize().then((response) => {
            $scope.areaOptions = response.data;
        });

        $scope.moveToArea = () => {
            if (1 == $scope.step) {
                if (!$scope.area_id) {
                    notify.danger($translate.instant('areas.choose_area'));
                } else {
                    $scope.step = 2;
                }
            } else if (2 == $scope.step) {
                const info = notify.info($translate.instant('saving'));
                notify.global(1);

                AreaModel.post({ model: $scope.model, area_id: $scope.area_id }, { pathSuffix: '/move' }).then((response) => {
                    $scope.model.area_id = response.area_id;
                    api($scope.model._model).clearCache();

                    info.close();
                    notify.overlay(1);
                    notify.success($translate.instant('areas.moved'));
                    $window.location.hash = '';
                    $window.location.reload();
                });
            }
        };
    },

    templateUrl: '/directives/area/area-move.html',
}));
